import axios from 'axios';
import { AppData, Calendar, FormattedEvent, FetchResult, FetchError } from '../types';
import { isPastDate, getTimeDifferenceInMs, fiveHoursInMs, isFutureDate } from '../functions/date';

export const fetchAppData = async (verein: String|undefined): Promise<AppData|null> => {
    const url = `/.netlify/functions/get-calendars?verein=${verein}`;
    try {
        const response = await axios.get(url);
        return response.data;
    } catch (error:any) {
        console.error(`Error fetching calendars from ${url}:`, error.message);
        return null;
    }
};

export async function fetchEvents(appData: AppData): Promise<FetchResult[]> {
  const url = '/.netlify/functions/fetch-ical';

  const requests = appData.calendars.map(calendar => {
    console.log(`Fetching iCal for calendar: ${calendar.Team.Name}`);
    return axios.post(url, JSON.stringify(calendar), {
      headers: { 'Content-Type': 'application/json' }
    }).then(response => {
      const events: FormattedEvent[] = response.data.events || [];
      const result: FetchResult = {
        calender: calendar.Team.Name,
        events: addMetaInfoToEvents(
          events.filter((event: FormattedEvent) =>
            event.id && event.title && event.start && event.end
          ),
          calendar,
          appData.verein.Name
        ),
        errors: []
      }
      return result
    }).catch(error => {
      console.error(`Error fetching iCal for calendar ${calendar.Team.Name}:`, error.message);
      const fetchError: FetchError = {
          team: calendar.Team.Name,
          error: error
        }
      const result: FetchResult = {
        calender: calendar.Team.Name,
        events: [],
        errors: [fetchError]
       } // fallback for failed request
       return result;
    });
  });

  const results = await Promise.allSettled(requests);
  return results
    .filter(result => result.status === 'fulfilled')
    .map((result: any) => result.value as FetchResult);
};

const addMetaInfoToEvents = (events: FormattedEvent[], calendar: Calendar, verein: string): FormattedEvent[] => {
  return events
  .map(event => addLiveInfoToEvent(event))
  .map(event => addCategoryToEvent(event, calendar, verein));
}

const addLiveInfoToEvent = (event: FormattedEvent): FormattedEvent => {
    // load ergebnis if the end date - 5h is in the past
    // 5h is the maximum length of a spiel we expect to also show it as live
    // event.start = event.end from iCal if no end is set yet from spielbericht
    const eventEndInvalid = getTimeDifferenceInMs(event.start, event.end) > fiveHoursInMs;
    // if the spielbericht has a wrong end date (more than 5h after start), use start date for past check
    const eventDate = eventEndInvalid ? event.start : event.end;
    // The Event Subscription shall be possible for all events in the future
    // and for live events (end date + 5h is not in the past)
    event.shallShowEventSubscription = isFutureDate(eventDate) || isFutureDate(eventDate, new Date(-1* fiveHoursInMs))
    // load spielergebnis if the start is in the past
    event.shallLoadSpielErgebnis = isPastDate(event.start)
    // show live ergebnis if the end date + 5h is not in the past
    // 5h is the maximum length of a spiel we expect to also show it as live 
    event.shallShowLiveErgebnis = isPastDate(event.start) && isFutureDate(event.start, new Date(-1* fiveHoursInMs))
    console.log(`Event ${event.title} - Date: ${eventDate} - shallShowEventSubscription: ${event.shallShowEventSubscription} - shallLoadSpielErgebnis: ${event.shallLoadSpielErgebnis} - shallShowLiveErgebnis: ${event.shallShowLiveErgebnis}`);
    return event;
}

const addCategoryToEvent = (event: FormattedEvent, calendar: Calendar, verein: string): FormattedEvent => {
    event.category = getItemCategory(event, calendar, verein) || "other";
    return event;
};

const getItemCategory = (item: any, calendar: Calendar, verein: string ): string =>     {
  if (calendar.Team.Name === "" || calendar.Liga.Name === "") {
    return "other";
  }
  return item.title?.split(' vs ')[0].toLowerCase().includes(verein.toLowerCase()) ? "home" : "away";
}